import '@fortawesome/fontawesome-svg-core/styles.css';
import { SetupClient } from '@pkdigital/pkd-custom-components';
import Head from 'next/head';
import { useEffect, useState } from 'react';
import '../styles/styles.scss';
import useGlobalInit from '../hooks/app/useGlobalInit';
import '../i18n/config';

const title = 'JETZT NEU: Techem Heizkostenabrechnung';
const desc =
  'Heizkostenabrechnung leicht gemacht mit Techem Direct: Einfach, transparent und 100% digital. In 6 Klicks zum individuellen Angebot.';
const socialThumbnailImgUrl =
  'https://www.techem.de/fileadmin/user_upload/PKD/social-thumbnail.jpg';
const socialRefUrl = 'https://vermieter.techem.de/td-home';

const App = ({ Component, pageProps }) => {
  useGlobalInit();
  const [isClient, setIsClient] = useState<boolean>(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return !isClient ? (
    <></>
  ) : (
    <>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            const isClientSide = typeof window !== "undefined";
            if (isClientSide) {
              var userAgent = window.navigator.userAgent;
              if (
                // Edge:
                // The Legacy Edge indentifies as "Edge". The Chromium-based Edge indentifies as "Edg". Note the missing "e".
                // Only redirect the legacy Edge.
                userAgent.indexOf("Edge") > -1 ||
                // or IE10 or IE11
                window.matchMedia(
                  "(-ms-high-contrast: none), (-ms-high-contrast: active)"
                ).matches
              ) {
                // Go back to main base url to handle fallback page display.
                window.location.href = "/";
              }
            }
          `
        }}
      />
      <Head>
        <meta charSet="utf-8" />
        <title>{title}</title>

        {/* Optimization suggested by google LightHouse: https://web.dev/codelab-preload-web-fonts/ */}
        <link
          rel="preload"
          href="/td-home/fonts/UniversLTW02-55Roman.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          href="/td-home/fonts/UniversLTW02-65Bold.woff2"
          as="font"
          type="font/woff2"
          crossOrigin="anonymous"
        />

        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#ffffff" />
        <link rel="icon" href="/td-home/favicon.ico" />
        <meta name="title" content={title} />
        <meta name="description" content={desc} />
        <meta
          name="keywords"
          content="Heizkostenabrechnungen, Betriebskostenabrechnung, private Vermieter, online abrechnen"
        />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={socialRefUrl} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={desc} />
        <meta property="og:image" content={socialThumbnailImgUrl} />
        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content={socialRefUrl} />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={desc} />
        <meta property="twitter:image" content={socialThumbnailImgUrl} />
      </Head>
      <SetupClient />
      <Component {...pageProps} />
    </>
  );
};

export default App;
